import { PrinterOptionsSchema } from "@redotech/redo-model/printnode/printer";
import * as z from "zod/v4";

export const printPickList = {
  name: "printPickList" as const,
  input: z.intersection(
    z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
    z.object({
      printerId: z.number().optional(),
      printerOptions: PrinterOptionsSchema.optional(),
      idempotencyKey: z.string().optional(),
    }),
  ),
  output: z.object({ url: z.string(), batchFailed: z.boolean().nullish() }),
};

export type PrintPickListInput = z.infer<typeof printPickList.input>;
